import { useTheme } from "@mui/styles";
import { useOrderFlow } from "../../OrderFlowProvider/OrderFlowContext";
/**
 * Returns values to be used in the CartButton for showing a custom icon and pricing breakdown.
 * @returns customCartIconUrl, usesCustomCartIcon,
    isCustomCartIconWhite, usesSimplifiedPricingBreakdown
 */
export const useCartButton = () => {
    var _a, _b, _c, _d, _e, _f;
    const { store } = useOrderFlow();
    const theme = useTheme();
    const isCustomCartIconWhite = (_c = (_b = (_a = theme.custom) === null || _a === void 0 ? void 0 : _a.cartIcon) === null || _b === void 0 ? void 0 : _b.isWhite) !== null && _c !== void 0 ? _c : false;
    const customCartIconUrl = (_f = (_e = (_d = theme.custom) === null || _d === void 0 ? void 0 : _d.cartIcon) === null || _e === void 0 ? void 0 : _e.url) !== null && _f !== void 0 ? _f : "";
    const usesCustomCartIcon = !!customCartIconUrl;
    return {
        customCartIconUrl,
        usesCustomCartIcon,
        isCustomCartIconWhite,
        usesSimplifiedPricingBreakdown: store.model.CartSettings.DisplaySimplifiedPricingBreakdown,
    };
};
